"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
exports.InstanceChainMap = new utils_1.CompositeKeyWeakMap();
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./~/lodash-decorators/factory/common.js
// module id = 208
// module chunks = 0